module.exports = __webpack_public_path__ + "img/victor-storozhuk.4c67fdc9.jpg";